module.exports = __webpack_public_path__ + "img/pose-m-9.7c6d0eee.png";